"use client";

import classNames from "@/utils/classNames";

type CookieSettingsLinkProps = {
  className?: string;
  label?: string;
};

const CookieSettingsLink = ({
  className,
  label = "Cookie-Einstellungen",
}: CookieSettingsLinkProps) => {
  const openCookieSettings = () => {
    if (window.Cookiebot?.renew) {
      window.Cookiebot.renew();
      return;
    }

    window.CookieConsent?.renew?.();
  };

  return (
    <button
      type="button"
      className={classNames("text-left", className)}
      onClick={openCookieSettings}
    >
      {label}
    </button>
  );
};

export default CookieSettingsLink;
